/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASSES_FIGURE = 'fit-avatar-figure';

/**
 * Base classes for the element containing the image itself.
 * @type {String}
 */
export const BASE_CLASSES_IMAGE = 'fit-avatar-image';

/**
 * The class assigned when the avatar has a non-default background color.
 * @type {String}
 */
export const WHITE_FONT_CLASS = 'fit-avatar-white-font';

/**
 * Used by the "shape" prop to render either a square or circle avatar.
 * @type {Object<String>}
 */
export const SHAPES = {
    SQUARE: 'square',
    CIRCLE: 'circle'
};
